import React from 'react';
import logo from '../assets/img/logo.png';
import aprrovedIcon from '../assets/img/icon.png';
import Spinner from './Spinner';

const message=(text, aprroved, displaySpinner)=>(
  <div className="message-box">
    <img className="airrefund-logo" src={logo} alt="airrefund logo"/>
        <div className={aprroved ? "aprroved" : "error"}>
          {aprroved && <img src={aprrovedIcon} alt="aprroved icon"/>}
          {text}
          {displaySpinner && <Spinner />}
        </div>
  </div>
)

export default message;



// WEBPACK FOOTER //
// ./src/components/Message.js